/**
* 顶部菜单
*/
<template>
  <div>
    <!-- Home顶部功能区域 -->
    <div class="site-nav site-nav-bgc nav-bgc" id="site-nav">
      <div class="w w1200 nav-font">
        <ul class="quick-menu fl" style="height: 28px">
          <li>
            <div class="dt">
              <!-- <a href="/brand">品牌馆</a> -->
              <router-link to="/brand">品牌馆</router-link>
            </div>
          </li>
          <!-- <li class="spacer" v-if="userInfo.type" ></li> -->
          <!-- <li > -->
            <!-- v-if="showRegister" -->
            <!-- <div  class="dt" v-if="userInfo.type"> -->
              <!-- <a href="/welcomesystem">商家入驻</a> -->
              <!-- <router-link to="/welcomesystem" >商家入驻</router-link> -->
            <!-- </div> -->
          <!-- </li> -->
          <li class="spacer" v-if="copyRight.consumerHotline"></li>
          <li v-if="copyRight.consumerHotline">
            <div class="dt">
              <a href="javascript:;"
                ><i class="el-icon-phone"></i> HELLO:{{
                  copyRight.consumerHotline
                }}</a
              >
            </div>
          </li>
          <li class="spacer" v-if="showAppCode"></li>
          <li class="li_dorpdown">
            <div class="dt" v-if="showAppCode">
              <a
                href="javascript:;"
                @mouseenter="showapp = !showapp"
                @mouseleave="showapp = !showapp"
                ><i class="el-icon-mobile-phone"></i> APP下载
                <i class="el-icon-arrow-down"></i
              ></a>
            </div>
            <!-- 隐藏区域 -->
            <transition name="el-zoom-in-top">
              <div
                v-show="showapp"
                class="dropdown-menu"
                style="
                  z-index: 10000000;
                  position: absolute;
                  border-top: 2px solid #ff6700;
                  background: #fff;
                  padding: 6px;
                "
              >
                <div class="qrcode" ref="qrCodeUrl"></div>
                <!-- <el-image
                  :src="appimg"
                  fit="fill"
                  style="width: 160px; height: 160px"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image> -->
              </div>
            </transition>
          </li>
          <li class="spacer"></li>
          <li>
            <div class="dt">
              <a
                href="javascript:;"
                @mouseenter="showwx = !showwx"
                @mouseleave="showwx = !showwx"
                ><i class="el-icon-mobile-phone"></i> 微商城
                <i class="el-icon-arrow-down"></i
              ></a>
            </div>
            <!-- 隐藏区域 -->
            <transition name="el-zoom-in-top">
              <div
                v-show="showwx"
                class="dropdown-menu"
                style="
                  z-index: 10000000;
                  position: absolute;
                  border-top: 2px solid #ff6700;
                "
              >
                <div class="qrcode" ref="qrCodeUrls"></div>
                <!-- <el-image
                  :src="appimg"
                  fit="fill"
                  style="width: 160px; height: 160px"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image> -->
              </div>
            </transition>
          </li>
          <li class="spacer"></li>
          <li>
            <div class="amap-page-container nav-area">
              <el-amap
                vid="amap"
                :plugin="plugin"
                class="amap-demo"
                :center="center"
              >
              </el-amap>
              <div class="toolbar">
                <span
                  v-if="loaded"
                  style="color: rgb(230, 162, 60, 1); border-radius: 4px"
                >
                  <i class="el-icon-location"></i> {{ city }}
                </span>
                <span v-else>正在定位</span>
              </div>
            </div>
          </li>
        </ul>
        <!-- <div class="fl">
          <div class="city-choice" id="city-choice" data-ectype="dorpdown">
            <div class="dsc-choie dsc-cm" ectype="dsc-choie">
              <img src="images/place.png" class="place" />
              <input type="text" value="全国" class="search" />
            </div>
          </div>
        </div> -->
        <ul class="quick-menu fr" style="height: 28px">
          <li>
            <div class="dt">
              <!-- <a href="/login" v-if="userInfo.loginName==null?true:false">登录</a> -->
              <router-link
                to="/login"
                v-if="userInfo.loginName == null ? true : false"
                >登录</router-link
              >
              <!-- <a  v-if="userInfo.userName==null?false:true">{{userInfo.userName}}</a> -->
            </div>
            <el-dropdown>
              <span class="el-dropdown-link" style="cursor: pointer">
                <a v-if="userInfo.loginName == null ? false : true">{{
                  userInfo.userName || userInfo.loginName
                }}</a></span
              >
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  ><a style="color: black" href="javaScript:;" @click="rollOut"
                    >退出</a
                  ></el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <li
            v-if="userInfo.loginName == null ? true : false"
            class="spacer"
          ></li>
          <li>
            <div class="dt">
              <!-- <a href="/register" v-if="userInfo.loginName==null?true:false">注册</a> -->
              <router-link
                to="/register"
                v-if="userInfo.loginName == null ? true : false"
                >注册</router-link
              >
            </div>
          </li>
          <li class="spacer"></li>
          <li>
            <div class="dt">
              <!-- <a href="/myOrder">我的订单</a> -->
              <router-link to="/myOrder">我的订单</router-link>
            </div>
          </li>
          <li class="spacer"></li>
          <!-- <li>
            <div class="dt">
              <a href="#">我的浏览</a>
            </div>
          </li> -->
          <!-- <li class="spacer"></li> -->
          <li>
            <div class="dt">
              <!-- <a href="#">我的收藏</a> -->
              <router-link to="/goodsCollection">我的收藏</router-link>
            </div>
          </li>
          <!-- <li>
            <div class="dt">

              <router-link to="/serviceGoods">服务类</router-link>
            </div>
          </li> -->

          <li class="spacer"></li>
          <li>
            <!-- <div class="dt">
              <a href="#">客户服务</a>
            </div> -->
            <el-dropdown>
              <span class="dt el-dropdown-link" style="cursor: pointer">
                客户服务</span
              >
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(articleItem, index) in helpArticle"
                  :key="index"
                >
                  <router-link :to="articleItem.categoryDesc">{{
                    articleItem.categoryName
                  }}</router-link>
                </el-dropdown-item>
                <!-- <el-dropdown-item
                  ><router-link to="/siteHelp?articleId=5&categoryId=5"
                    >售后服务</router-link
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  ><router-link to="/siteHelp?articleId=6&categoryId=4"
                    >客户中心</router-link
                  ></el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <li class="spacer"></li>
          <li>
            <el-dropdown>
              <span class="dt el-dropdown-link" style="cursor: pointer">
                站点导航</span
              >
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  ><router-link to="/siteNavigation"
                    ><a style="color: black">用户中心</a></router-link
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  ><router-link to="/paymentCenter"
                    ><a style="color: black">支付中心</a></router-link
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  ><router-link to="/"
                    ><a style="color: black">网站首页</a></router-link
                  ></el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </ul>
      </div>
    </div>
    <!-- 广告位 -->
    <div class="guanggao" v-if="Advert"   @mouseenter="mouseenterAdvert"
        @mouseleave="mouseLeaveAdvert">
      <el-image


        :src="AdPostionImg"
      >
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
      <div class="close"  v-if="close"  @click="handleAdvert">关闭</div>
    </div>

    <!-- <h1
          >广告位

            </h1> -->

    <!-- logo+收索 -->
    <div class="w w1200">
      <el-row class="logotop" type="flex" justify="center" align="top">
        <el-col :span="8">
          <div class="fl">
            <el-image
              @click="$router.push('/')"
              class="logo"
              style="cursor: pointer"
              :src="logo"
              fit="fill"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <el-image
              v-if="showRegister"
              :src="require('@/assets/images/ecsc-join.gif')"
              fit="fill"
              style="border-radius: 5px"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-input
              :placeholder="hotSearchList[0]"
              v-model="searchInput"
              @keyup.enter.native="getSearchClick('')"
              class="input-with-select"
              style="border: 1px solid #e13c41; border-radius: 4px"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                style="font-size: 22px; z-index: 10000"
                @click="getSearchClick('')"
              ></el-button>
            </el-input>
          </div>
          <div style="margin-top: 5px; text-align: left">
            <span v-for="(item, index) in hotSearchList" :key="index">
              <!-- <router-link :to="`/goodsList?adWord=${item}`">{{item}}</router-link> -->
              <!-- <router-link :to="`/goodsList?adWord=${item}`">{{item}}</router-link> -->
              <span @click="getSearchClick(item)">{{ item }}</span>
              <el-divider direction="vertical"></el-divider>
            </span>
          </div>
        </el-col>
        <el-col :span="4" style="text-align: right;line-height:46px">
          <div class="grid-content bg-purple">
            <el-popover placement="top-start" width="400" trigger="click">
              <div class="cartTip">
                <el-row
                  :gutter="20"
                  class="cartBox"
                  v-for="(item, index) in list"
                  :key="index"
                >
                  <el-col :span="5"
                    ><el-image
                      class="cartgoodsPhotos"
                      :src="`${item.photos}`"
                    ></el-image
                  ></el-col>
                  <el-col :span="11"
                    ><div class="cartHeight" title="">
                      {{ item.name }}
                    </div></el-col
                  >
                  <el-col :span="6"
                    ><div class="cartHeight">
                      {{ item.realprice }} * {{ item.number }}
                    </div></el-col
                  >
                </el-row>
                <el-row>
                  <el-col :span="24" v-if="totalNumber == 0 ? true : false"
                    >进货单还没有商品,赶紧选购吧!</el-col
                  >
                </el-row>
                <el-row class="cartBox_footer">
                  <el-col :span="12"
                    ><div class="cartHeight_total">
                      <p class="totalNum">共 {{ totalNumber || 0 }} 件商品</p>
                      <p>{{ accountTotal.toFixed(2) || 0 }} 元</p>
                    </div></el-col
                  >
                  <el-col :span="12"
                    ><div class="cartHeight_cart">

                      <router-link to="/shoppingcart" style="color: white"
                        >

                        去进货单结算</router-link
                      >
                    </div></el-col
                  >
                </el-row>
              </div>
              <!-- 进货单 -->

  <el-button slot="reference" class="shopgoods"
                ><i class="el-icon-shopping-cart-full"></i> 进货单 ({{
                  totalNumber
                }})
              </el-button>
               <el-button v-if="userInfo.type" class="inquiry-but" slot="reference"
                > <router-link to="/welcomesystem" ><i class="el-icon-s-promotion"></i> 入驻</router-link>

              </el-button>
              <!-- 采购 -->
            </el-popover>

          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 顶部菜单 -->
    <div id="menu2019" class="min-w1200">
      <div class="w w1200" v-if="isShowNav">
        <div class="categorys">
          <div
            class="categorys-type"
            @mouseenter="mouseenterBox"
            @mouseleave="mouseLeaveBox"
          >
            <a href="javascript:;" style="color: white; font-size: 16px"
              ><i class="el-icon-menu classification"></i> 全部商品分类</a
            >
          </div>
          <!-- 隐藏分类 -->
          <div
            class="categorys-tab-content"
            v-show="isShowCategoryList"
            @mouseleave="mouseLeaveBox"
          >
            <div class="categorys-items" id="cata-nav">
              <!-- 商品分类start -->
              <div
                class="categorys-item"
                v-for="(oneItem, index) in categoryList"
                :key="index + '_item'"
              >
                <div class="item item-content">
                  <i class="iconfont icon-ele"
                    ><img
                      :src="oneItem.categoryOne.icon"
                      style="vertical-align: baseline"
                      onerror="javascript:this.src='http://xyss.com.cn/tag.png';"
                  /></i>
                  <div class="categorys-title">
                    <strong>
                      <router-link
                        :to="`/goodsList?parentBxscId=${oneItem.categoryOne.bxscId}&secondCategory=true`"
                        >{{ oneItem.categoryOne.name }}</router-link
                      >
                    </strong>
                    <!-- 展示全部商品分类 -->
                    <!-- <span><i></i></span>
                     <span >
                    <router-link
                      :to="`/goodsList?parentBxscId=${subItems.category.bxscId}&secondCategory=true`"
                      v-for="(subItems, index) in oneItem.subItems.slice(0, 2)"
                      :key="index + '_sub'"
                      ><template>{{
                        subItems.category.name
                      }}</template></router-link
                    >
                  </span>  -->
                  </div>
                </div>
                <div class="categorys-items-layer categorys-items-second-layer">
                  <div class="cate-layer-con clearfix">
                    <!-- 展示二级分类 -->
                    <div class="cate-layer-second" v-if="!showThreeClass">
                      <div
                        class="cateChanneSecond"
                        v-for="(subItem, index) in oneItem.subItems.slice(0, 6)"
                        :key="index + 'sunItem'"
                      >
                        <!--滑动展示区域 -->
                        <router-link
                          class="cateChanneSecondName"
                          :to="`/goodsList?parentBxscId=${subItem.category.bxscId}&secondCategory=true`"
                        >
                          <el-image
                            :src="
                              subItem.category.icon
                                ? subItem.category.icon
                                : 'http://xyss.com.cn/no.png'
                            "
                            fit="fill"
                          >
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"></i>
                            </div>
                          </el-image>
                          <div>
                            {{ subItem.category.name }}
                          </div>
                        </router-link>
                      </div>
                    </div>
                    <!-- 展示三级 分类 -->

                    <div class="cate-layer-left" v-if="showThreeClass">
                      <div class="cate_channel">
                        <!-- 三级分类button -->
                        <router-link
                          :to="`/goodsList?parentBxscId=${subItem.category.bxscId}&secondCategory=true`"
                          v-for="(subItem, index) in oneItem.subItems.slice(
                            0,
                            6
                          )"
                          :key="index + 'sunItem'"
                          >{{ subItem.category.name }}</router-link
                        >
                      </div>
                      <div class="cate_detail">
                        <dl
                          v-for="(subItem, index) in oneItem.subItems"
                          :key="index + 'sunItem'"
                          :class="'dl_fore' + (index + 1)"
                        >
                          <dt>
                            <router-link
                              :to="`/goodsList?parentBxscId=${subItem.category.bxscId}&secondCategory=true`"
                              >{{ subItem.category.name }}</router-link
                            >
                          </dt>
                          <dd>
                            <router-link
                              :to="`/goodsList?parentBxscId=${thrItem.bxscId}&secondCategory=true`"
                              v-for="(thrItem, index) in subItem.sub"
                              :key="index + '_thr'"
                              >{{ thrItem.name }}</router-link
                            >
                          </dd>
                        </dl>
                      </div>
                    </div>
                    <div
                      v-if="oneItem.subItems.length == 0 ? true : false"
                      class="nodataCss"
                    >
                      <p>暂无相关分类数据</p>
                    </div>
                    <!-- <div class="cate-layer-rihgt">
                    <h3>热门推荐</h3>
                    <div class="cate-layer-right-slide">
                      <img th:src="@{/portal/images/elec1.jpg}" />
                    </div>
                    <div class="cate-layer-right-slide">
                      <img th:src="@{/portal/images/elec1.jpg}" />
                    </div>
                  </div> -->
                  </div>
                </div>
                <div class="clear"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="nav-main weight">
          <!-- <a href=""><i class="fa fa-bars"></i> 全部商品分类</a> -->
          <!-- 标题分类 -->
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            router
            @select="handleSelect"
          >
            <!-- navUrl -->
            <!--   && item.navTitle=='服务类专题'?false:true  -->
            <template v-for="(item, index) in navList" >
              <el-menu-item
                :index="item.navUrl"
                :key="index + '_nav'"
                :route={path:item.navUrl,query:{navId:item.navId,}}
                v-if=" item.navTitle != '商家店铺' && item.navTitle != '批发市场'  && item.navTitle != '招标采购'  "
              >
                <i>{{ item.navTitle }}</i>
              </el-menu-item>
            </template>

            <template v-for="(item, index) in navList">
              <el-menu-item
                :index="item.navUrl"
                :key="index + '_nav'"
                :route={path:item.navUrl,query:{navId:item.navId,}}
                v-if=" item.navTitle == '批发市场'&&userInfo.type==2"
              >
                <i>{{ item.navTitle }}</i>
              </el-menu-item>
            </template>

              <template v-for="(item3, index) in navList">
              <el-menu-item
                :index="item3.navUrl"
                :key="index + '_nav'"
                :route={path:item3.navUrl,query:{navId:item3.navId,}}
                v-if=" (item3.navTitle == '招标采购'&& userInfo.type==1)|| (item3.navTitle == '招标采购'&& userInfo.type==3)||(item3.navTitle == '招标采购'&& !userInfo.type) ||(item3.navTitle == '招标采购'&& userInfo.type==0) "
              >
                <i>{{ item3.navTitle }}</i>
              </el-menu-item>
            </template>

            <template v-for="(item1, index) in navList">
              <el-menu-item
                index=""
                :key="index + '_nav1'"
                v-if="
                  item1.navTitle == '商家店铺' &&
                  userInfo.type == '2'
                "
              >
                <a :href="userInfo.type==2?`${$baseUrl}${item1.navUrl}`:'#/login'" target="_blank"><i>{{ item1.navTitle }}</i></a>
              </el-menu-item>
            </template>
          </el-menu>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript" src="../assets/js/kuCity.js"></script>
<script>
import { menu } from "../api/userMG";
import mainlayout from "../components/layout/mainlayout";
import {
  navList,
  getAdPostionImg,
  leftMenuList,
  shoppingCartlist,
  hot_search,
  search_list,
  setImage,
  systemConfig,
  apiConfig,
  apiHelpArticle,
} from "@/api/xunyou";
import { mapState, mapMutations } from "vuex";
import QRCode from "qrcodejs2";
import bus from "@/utils/bus"; //引入事件中心
export default {
  name: "leftnav",
  inject: ["reload"],
  data() {
    let self = this;
    return {
      loading: false,
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      // input: "",
      // accountTotal:0,
      // goodsnum: 0,
      showapp: false, //app不显示
      appimg:
        "https://ceshi.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200806/1596701627449534.png",
      showwx: false, //微信不显示
      show2: false, //默认进入不显示
      collapsed: false,
      allmenu: [],
      //  list:[], //进货单的数据
      //地图
      center: [121.59996, 31.197646],
      city: "全国",
      lng: 0,
      lat: 0,
      loaded: false,
      logo: "",
      Advert: true,
      plugin: [
        {
          pName: "Geolocation",
          events: {
            init(o) {
              // o 是高德地图定位插件实例
              o.getCurrentPosition((status, result) => {
                if (result && result.position) {
                  self.$store.commit(
                    "gotCurrentAddress",
                    result.addressComponent
                  );
                  console.log(result, "|wb");
                  self.lng = result.position.lng;
                  self.lat = result.position.lat;
                  self.city =
                    result.addressComponent.city ||
                    result.addressComponent.district;
                  self.center = [self.lng, self.lat];
                  self.loaded = true;
                  self.$nextTick();
                }
              });
            },
          },
        },
      ],
      AdPostionImg: require('@/assets/images/adret.png'),
      navList: [],
      activeIndex: "1",
      categoryList: [],
      hotSearchList: [],
      searchInput: "",
      isShowCategoryList: false,
      appUrl: "",
      appUrl: "",
      showThreeClass: false, // 是否展示三级分类
      helpArticle: [],
      showAppCode: false,
      showRegister: true,
      close: false,
    };
  },
  // 注册组件
  components: {
    mainlayout,
  },
  computed: {
    ...mapState([
      "isShowNav",
      "list",
      "accountTotal",
      "totalNumber",
      "copyRight",
    ]),
  },
  watch: {
    $route(to, from) {
      if (to.path != "/") {
        // 其他页面不展示全部商品分类
        this.isShowCategoryList = false;
      } else {
        //// 只在首页展示全部商品分类
        this.isShowCategoryList = true;
      }
      if (to.path != "/shoppingcart") {
        // 其他页面不展示全部商品分类
        //  this.onload()
        this.getshoppingCartlist();
      }

    },
  },

  // 挂载结束状态(里面是操作)
  mounted() {
    //  console.log(this.userInfo.type,"userInfo");
    //获取广告位的图片
    this.getPostionImg();
    // this.city();
    // if(this.userInfo.loginName!=null||this.userInfo.loginName!="" ){
    //       this.getshoppingCartlist();
    // }
    // this.getSearchList() // pc端不需要该接口，属于手机端
    if (this.$route.path == "/") {
      this.isShowCategoryList = true; // 展示全部商品分类
    }
    this.getSystemConfig();
    this.gethotSearch();
    this.getImagelogo();

    this.getshoppingCartlist();
    this.getApiConfig();
    this.getTopApiConfig("appDownload");
    this.getTopApiConfig("merchantSettled");
    this.getApiHelpArticle();
  },
  // 里面的函数只有调用才会执行（实时计算）里面是定义的方法
  methods: {
    getPostionImg() {
      getAdPostionImg().then((res) => {
        if (res.code == 0) {
          if(res.data.img !==''){
            // console.log("meit");
            // this.AdPostionImg = res.data.img;
            this.AdPostionImg = 'https://gstianze.com/center/profile/upload/2022/01/20/e267c510c6644da8a6a1f3e950dc769a.png';
          }

        }
        // console.log(res,"resresres");
      });
    },

    handleAdvert() {
      console.log(111);
      if (this.Advert) {
        this.Advert = false;
      } else {
        this.Advert = true;
      }
    },
    //鼠标移入事件
    mouseenterAdvert() {
      this.close = true;
    },
    //鼠标移出事件
    mouseLeaveAdvert() {
       this.close = false;
    },
    // app下载 ==== app
    creatQrCode() {
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: this.appUrl, // 需要转换为二维码的内容
        width: 100,
        height: 100,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    // 微商城 ====H5
    creatH5QrCode() {
      var qrcode = new QRCode(this.$refs.qrCodeUrls, {
        text: this.H5Url, // 需要转换为二维码的内容
        width: 100,
        height: 100,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },

    // 获取系统参数
    getSystemConfig() {
      systemConfig().then((res) => {
        if (res.code == 0) {
          res.rows.forEach((element) => {
            if (element.configKey == "appUrl") {
              this.appUrl = element.configValue;
            }
            if (element.configKey == "H5Url") {
              this.H5Url = element.configValue;
            }
          });
          this.creatQrCode();
          this.creatH5QrCode();
        }
      });
    },

    // 获取系统参数 == 是否展示商家入口/是否app二维码下载
    getTopApiConfig(key) {
      apiConfig({
        key: key,
      }).then((res) => {
        if (res.code == 0) {
          if (res.rows.length > 0) {
            if (key == "merchantSettled") {
              this.showRegister = res.rows[0].configValue == 1 ? true : false; // 1开，2关
            } else {
              this.showAppCode = res.rows[0].configValue == 1 ? true : false; // 1开，2关
            }
          }
        }
      });
    },

    // 获取系统参数 == 是否展示三级分类
    getApiConfig() {
      apiConfig({
        key: "show_three_class",
      }).then((res) => {
        if (res.code == 0) {
          if (res.rows.length > 0) {
            this.showThreeClass = res.rows[0].configValue == 1 ? true : false; // 1开，2关
          }
        }
      });
    },

    // 系统参数 == 客户服务
    getApiHelpArticle() {
      apiHelpArticle().then((res) => {
        if (res.code == 0) {
          if (res.data.length > 0) {
            this.helpArticle = res.data || [];
          }
        }
      });
    },

    // 获取进货单

    getshoppingCartlist() {
      shoppingCartlist({ uid: this.userInfo.userId || "" })
        .then((res) => {
          if (res.length > 0) {
            this.$store.commit("getCartList", res);
          }
        })
        .catch((err) => {
          this.$message.error("进货单查询失败，请稍后再试！");
        });
    },
    getSearchClick(name) {
      let path = this.$route.path;
      let val = "";
      if (name) {
        val = name;
        this.searchInput = name;
      } else {
        val = this.searchInput == "" ? this.hotSearchList[0] : this.searchInput;
      }
      if (!this.searchInput) {
        this.searchInput = this.hotSearchList[0];
      }
      // if (path !== "/goodsList") {
      if (path.includes("supplier")) {
        this.$router.push(`/goodsList_supplier?adWord=${val}`);
      } else {
        if (path != "/goodsList") {
          this.$router.push(`/goodsList?adWord=${val}`);
          return;
        } else {
          let query = JSON.parse(JSON.stringify(this.$route.query));
          query.adWord = val;
          this.$router.replace({
            query,
          });
          bus.$emit("search", val);
        }
      }
    },

    // 获取logo
    getImagelogo() {
      setImage().then((res) => {
        if (res.code == 0) {
          this.logo = res.rows[0].pcLogo;
        }
      });
    },
    // 鼠标移入移出
    mouseenterBox() {
      if (this.$route.path == "/") {
        this.isShowCategoryList = true;
        //   this.isShowCategoryList = !this.isShowCategoryList;
        // } else {
        //   this.isShowCategoryList = false;
      }
      //
    },
    // 鼠标移入移出
    mouseLeaveBox() {
      if (this.$route.path == "/") {
        this.isShowCategoryList = true;
        //    this.isShowCategoryList = !this.isShowCategoryList;

        // } else {
        //     this.isShowCategoryList = false;
      }
    },
    // 退出登录
    rollOut() {
      localStorage.removeItem("userdata");
      this.$router.push("/login");
      window.location.reload();
    },
    // 进货单查询
    // getshoppingCartlist() {
    //   this.accountTotal =0
    //    this.loading = true
    //   shoppingCartlist({uid:this.userInfo.userId||''})
    //     .then((res) => {
    //       this.loading = false
    //      let newList= []
    //       res.forEach((x)=>{
    //           x.bxunyouMerchant.goods.forEach((y)=>{
    //             newList.push(y)
    //           })
    //       })
    //         this.list = newList;
    //         let sum = this.list.reduce((sum, item) => {
    //                   return sum + item.realprice * item.number; // 隐式转换
    //               }, 0);
    //               this.accountTotal += sum;
    //         console.log(this.list,'获取进货单内容ffffffffff')
    //         })
    //     .catch((err) => {
    //       // this.$message.error("查询进货单失败，请稍后再试！");
    //     });
    // },
    // 菜单
    searchNavList() {
      this.loading = true;
      navList()
        .then((res) => {
          if (res.code == 0) {
            this.loading = false;
            this.navList = res.data;
            console.log(res.data,"菜单");
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.editFormVisible = false;
          this.loading = false;
          this.$message.error("加载失败，请稍后再试！");
        });
    },
    // 左侧菜单
    searchleftMenuList() {
      this.loading = true;
      leftMenuList()
        .then((res) => {
          if (res.code == 0) {
            this.categoryList = res.data.slice(0, 11);
            // console.log(res.data,"res");
            this.loading = false;
            // this.categoryList = res.data.slice(0, 10);
            // console.log( res.data,"this.categoryList");
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.editFormVisible = false;
          this.loading = false;
          this.$message.error("加载失败，请稍后再试！");
        });
    },
    handleSelect(key, keyPath) {
      // if (this.$route.path =='/service') {

      // }
    },


    // 热门搜索
    gethotSearch() {
      hot_search()
        .then((res) => {
          if (res.code == 0) {
            this.hotSearchList = res.data.column10.split(",");
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("加载失败，请稍后再试！");
        });
    },
    // 默认搜索
    getSearchList() {
      search_list()
        .then((res) => {
          if (res.code == 0) {
            this.searchInput = res.rows[0].column1;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("加载失败，请稍后再试！");
        });
    },
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.searchNavList();
    this.searchleftMenuList();
  },
};
</script>
<style lang="less" scoped>
#menu2019 {
  border-bottom: #cd0000 3px solid;
}

// margin-top: -28px;
// background-color: rgba(0, 0, 0, 0.1);
.guanggao {
  margin-top: -1px;
  margin-bottom: 10px;
  cursor: pointer;
  position: relative;
  .el-image {
    width: 100%;
    height: 100px;
    background-repeat: no-repeat;
    background-position: center;
  }
  .close {
    z-index: 99;
    position: fixed;
    top:30px;
    right:40px;
    width: 40px;
    font-size: 18px;
    color: white;
    height: 10px;
    line-height: 10px;
    padding: 10px;
    text-align: center;
    background-color: rgba(41, 40, 40, 0.6);
  }
}

/deep/ .logo img {
  width: 255px;
  height: 52px;
}
.logotop {
  margin: 0.2rem 0;
}
.el-input-group__append {
  border-left: 0;
  background-color: #e13c41;
}
.el-input-group__append,
.el-input-group__prepend {
  background-color: #e13c41;
  color: white;
  vertical-align: middle;
  display: table-cell;
  position: relative;
  border: 0px;
  border-radius: 4px;
  padding: 0 20px;
  width: 1px;
  white-space: nowrap;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.shopgoods{
   width: 132px;
}
/* 进货单样式 */
button.el-button.shopgoods.el-button--default.el-popover__reference:hover {
  border: 1px solid #e13c41;
  color: #e13c41;
  width: 132px;
  background: #fff;
}

/* top菜单 wb start*/
.categorys-tab-content .categorys-title strong a {
  color: #303133;
  font-size: 14px;
}

.categorys-tab-content .item-content {
  height: 60px;
}
/* top菜单 wb end*/
.categorys {
  float: left;
  width: 232px;
  height: 40px;
  position: relative;
}
.weight {
  font-weight: bolder;
}
.el-menu-item i {
  color: black;
}
.site-nav-bgc {
  background: #f7f8f8;
}
.nav-bgc {
  background: #444851;
}

/deep/.quick-menu li a {
  height: 40px;
  color: white !important;
  font-size: 13px;
}

.categorys-type {
  text-align: center;
  font-size: 22px;
  height: 40px;
  line-height: 40px;
  border-radius: 10px 10px 0 0;
  background-color: rgba(228, 1, 0, 1);
  width: 232px;
}
.inquiry-but {
  width: 132px;
  color: white !important;
  padding: 11px 20px;
  border-radius: 2px;
  border-color: #c65442;
  background: #c65442;
  a{
    color: white;
  }
}

// a{
//   color: black;
// }

/**wb end */
.categorys-type a {
  font-size: 16px;
  font-weight: 700;

  display: block;
}
/deep/.el-dropdown {
  color: #fff !important;
}
.nav-area {
  color: #e6a23c;
  font-size: 13px;
}
.nav-main {
  float: left;
  width: 968px;
  overflow: hidden;
  height: 40px;
  line-height: 40px;
  font-size: 15px;
}

.el-menu--horizontal > .el-menu-item {
  float: left;
  height: 40px;
  font-size: 15px;
  line-height: 40px;
  margin: 0;
  border-bottom: 2px solid transparent;
  color: #909399;
}

/deep/.el-menu--horizontal > .el-menu-item.is-active {
  color: #ff6700 !important;
  font-weight: bold;
}

/* 分类表 */
.categorys-tab-content {
  margin-top: 8px;
  box-sizing: border-box;
  z-index: 30;
  font-weight: bold;
  display: block;
  position: relative;
  height: 462px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 4px 0px rgba(103, 103, 103, 0.4);
  width: 232px;
}

.categorys-tab-content .categorys-items {
  padding: 10px 0;
  position: relative;
  font-weight: bold;
  height: 100%;

  box-sizing: border-box;
}
.categorys-tab-content .categorys-item:hover {
  background-color: #cd0000;
}
.categorys-tab-content .categorys-item:hover strong a {
  color: white;
}
.categorys-tab-content .categorys-item {
  cursor: pointer;
  height: 30px;
  line-height: 15px;
  padding: 10px;
  padding-bottom: 0;
}

.categorys-tab-content .item-content {
  padding: 0px 16px;
  float: left;
  width: 200px;

  height: 25px;
  line-height: 18px;
  display: flex;
}
.categorys-tab-content .item-content .icon-other {
  float: left;
  width: 18px;
  height: 18px;
}
.categorys-tab-content .iconfont {
  float: left;
  color: #bfbfbf;
  // margin-top: px;
  margin-top: 5px;
}
.categorys-tab-content .item-content .icon-other img {
  width: 100%;
}

.categorys-tab-content .selected .item-content {
  background-color: rgba(0, 0, 0, 1);
}

.categorys-tab-content .iconfont {
  float: left;
  color: #bfbfbf;
}

.categorys-tab-content .categorys-title {
  float: left;
  margin-left: 20px;
  text-align: left;
}

.categorys-tab-content .categorys-title strong {
  display: block;
  font-weight: normal;
}

.categorys-tab-content .categorys-title strong a {
  font-weight: bold;
  color: black;
  font-size: 14px;
}

.categorys-tab-content .categorys-title span {
  display: block;
  font-size: 0;
  font-size: 18px;
  // color: #000 !important;
}

.categorys-tab-content .categorys-title span a {
  margin-right: 10px;
  font-size: 18px;
}
// .categorys-tab-content :hover{
//   background-color: blue;
// }
.categorys-tab-content .categorys-title strong a {
  display: block;
  margin-top: 5px;
}
.categorys-tab-content .categorys-title span a:hover,
.categorys-tab-content .categorys-title strong a:hover {
  // color: white;
  font-size: 14px;
}

.categorys-items-layer {
  display: none;
  position: absolute;
  top: 0;
  left: 232px;
  width: 966px;
  height: 430px;
  border: 1px solid #fff;
  background-color: #fff;
  // border: #cd0000 3px solid;
  box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.1);
  -webkit-transition: top 0.25s ease;
  transition: top 0.25s ease;
  .nodataCss {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 14px;
  }
  // 二级分类
  .cate-layer-second {
    margin-top: 10px;
    height: 430px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 250px;
    .cateChanneSecond {
      margin-top: -10px;
      height: 27%;
      text-align: left;

      /deep/.el-image {
        width: 80px !important;
        height: 80px !important;
      }
      .cateChanneSecondName {
        align-items: center;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        display: block;
      }
    }
  }
}

/* 进货单的样式 */
.cartTip {
  .cartBox.el-row {
    margin: 15px;
    // background: red;
    height: 80px;
    .el-image.cartgoodsPhotos {
      height: 80px;
      width: 100%;
      position: inherit;
    }
    .cartHeight {
      height: 80px;
      line-height: 80px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .cartHeight_total {
    font-size: 18px;
    padding: 0 20px;
    color: #ff6700;
    .totalNum {
      font-size: 14px;
      color: #000;
    }
  }
  .cartHeight_cart {
    height: 40px;
    text-align: center;
    line-height: 40px;
    background: #ff6700;
    color: white;
    font-size: 15px;
    a.router-link-exact-active.router-link-active {
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topnav.vue